
//import api from "./api";
import api from "../../utils/axios";



// Submit a new pharmacy order
export const submitPharmacyOrder = async (payload) => {
    const response = await api.post("/auth/pharmacy/orders", payload);
    return response.data.data;
};

// Get an existing pharmacy order
export const getPharmacyOrder = async (orderId) => {
    const response = await api.get(`/auth/pharmacy/orders/${orderId}`);
    return response.data.data;
};

// Apply coupon


export const applyPharmacyCoupon = async (orderID, coupon) => {
    const response = await api.post("/auth/pharmacy/coupon", {
        orderID,
        coupon,
    });

    return response.data;
};

export const removePharmacyCoupon = async (orderID) => {
    const response = await api.post("/auth/pharmacy/coupon/remove", {
        orderID,
    });

    return response.data;
};


// Get pharmacy orders
export const getPharmacyOrders = async (tab = "active", page = 1) => {
    const response = await api.get("/auth/pharmacy/orders", {
        params: {
            tab,
            page,
        },
    });

    return response.data;
};
